import React, { Component, ErrorInfo } from 'react';
import { Navigate } from 'react-router-dom';

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<{ children: React.ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { 
    hasError: false 
  };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught in ErrorBoundary:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return <Navigate to="/error" state={{ 
        error: this.state.error?.message,
        componentStack: this.state.errorInfo?.componentStack
      }} />;
    }
    
    // @ts-ignore
    return this.props.children; 
  }
}

export default ErrorBoundary;